module.exports = __webpack_public_path__ + "img/product_04.e20f63ba.jpg";